<template lang="pug">
image-section(
  ref="image"
  can-remove
  can-edit
  block-interaction
  :section="section"
  @remove="$emit('removeSection', { index: sectionIndex })"
  @keyup.up="onArrowUp"
  @keyup.down="onArrowDown"
)
</template>

<script>
import ImageSection from '@/components/post/section/image-section'

export default {
  name: 'post-form__section--image',
  components: {
    ImageSection
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      default: null,
    },
  },
  methods: {
    resize() {
      return
    },
    focus() {
      this.$refs.image.focus()
    },
    onArrowUp(e) {
      if (e.shiftKey) {
        this.$emit('prevSection', { index: this.sectionIndex })
      }
    },
    onArrowDown(e) {
      if (e.shiftKey) {
        this.$emit('nextSection', { index: this.sectionIndex })
      }
    },
  },
}
</script>

<style lang="sass">
.post-from__section
  visibility: visible
</style>

